module.exports = __webpack_public_path__ + "static/media/montblanc-cillian-in-reverse.5b9bbc6c.gif";